<template>
  <div class="px-2">
    <b-card class="w-100 d-flex rounded-lg">

      <b-row align-h="end">
        <b-button
          class="btn rounded-pill"
          variant="primary"
          @click="addCategory()"
        >
          Create Category
        </b-button>
      </b-row>
      <center v-if="load">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <b-row class="py-2">
        <center
          v-if="!load && categories.data.length === 0"
          class="w-100 text-center mr-3"
        >
          <h3>No Data to show</h3>
        </center>
        <b-table
          v-if="!load && categories.data.length > 0"
          striped
          hover
          :items="categories.data"
          :fields="fields"
        >
          <template #cell(name)="data">
            <b-link
              v-if="data.item.id"
              :to="{ name: 'show_category', params: { id: data.item.id } }"
              class="text-primary font-weight-bold"
            >
              {{ data.item.name }}
            </b-link>
            <span v-else>{{ data.item.name }}</span>
          </template>

          <template #cell(Actions)="data">
            <div class="d-flex justify-content-start align-items-center">
              <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link mr-1"
                @click="showCategory(data.item.id)"
              >
                <feather-icon
                  v-b-tooltip.hover.top="'Show'"
                  :tooltip="'none'"
                  icon="EyeIcon"
                  size="18"
                />
              </b-link>
              <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link mr-1"
              >
                <feather-icon
                  v-b-tooltip.hover.top="'Edit'"
                  :tooltip="'none'"
                  icon="EditIcon"
                  size="18"
                  @click="$router.push({name: 'edit-category', params: {id: data.item.id} })"
                />
              </b-link>
              <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link text-danger"
                @click="deleteCategory(data.item.id)"
              >
                <feather-icon
                  v-b-tooltip.hover.top="'Delete'"
                  :tooltip="'none'"
                  icon="Trash2Icon"
                  size="18"
                />
              </b-link>
            </div>
          </template>
        </b-table>
      </b-row>
      <!-- Pagination & Per Page -->
      <b-row class="mt-2 w-100 align-items-center" v-if="categories && categories.meta">
        <b-col md="4" class="text-light d-flex align-items-center" style="font-size: 0.95rem;">
          <span v-if="categories.meta.total > 0" class="d-flex align-items-center" style="margin-left: 2px;">
            Showing 
            <b-form-select
              v-model="per_page"
              :options="[10, 25, 50, 100]"
              class="custom-per-page mx-1"
              @change="onPageChange(1)"
            />
          </span>
        </b-col>
        <b-col md="4" class="d-flex justify-content-center">
          <b-pagination
            v-model="categories.meta.current_page"
            :total-rows="categories.meta.total"
            :per-page="categories.meta.per_page"
            @change="onPageChange"
            class="mb-0"
          />
        </b-col>
        <b-col md="4"></b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BSpinner,
  BContainer,
  BRow,
  BCol,
  BButton,
  BCard,
  BTable,
  VBTooltip,
  BLink,
  BPagination,
  BFormSelect,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Categories',
  components: {
    BLink,
    VBTooltip,
    BSpinner,
    BContainer,
    BTable,
    BRow,
    BCol,
    BButton,
    BCard,
    BPagination,
    BFormSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      categories: 'categories/getCategories',
      load: 'categories/load',
    }),
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        // { key: "description", label: "Description", thStyle: { width: "50%" } },
        'Actions',
      ],
      isLoading: false,
      per_page: 10,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    addCategory() {
      this.$router.push({
        name: 'create_category',
      })
    },
    init() {
      this.$store
        .dispatch('categories/list', { page: 1, per_page: this.per_page })
        .then(response => {
          this.isLoading = false
        })
        .catch(e => {
          console.log(e.response)
          this.$swal({
            icon: 'error',
            title: `<h4>Error fetching category details: ${e.message}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        })
    },
    refresh() {
      this.$store.dispatch('categories/list', {
        page: this.categories.meta ? this.categories.meta.current_page : 1,
        per_page: this.per_page,
      })
    },
    onPageChange(page) {
      this.$store.dispatch('categories/list', { page, per_page: this.per_page })
    },

    deleteCategory(id) {
      this.isLoading = true
      this.$swal({
        title: '<h4>Are you sure you want to delete this category?</h4>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#7367f0',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch('categories/remove', id)
            .then(response => {
              this.isLoading = false
              this.$store.dispatch('categories/categoryLookups')
              this.$root.$emit('categoryCreated')
              this.refresh()
            })
            .catch(e => {
              this.isLoading = false
              this.$swal({
                icon: 'error',
                title: `<h4>${e.response.data.message}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            })
        }
      })
    },
    showCategory(id) {
      this.$router.push({
        name: 'show_category',
        params: { id },
      })
      this.$store
        .dispatch('categories/get', id)
        .then(response => {
          console.log('Categories shown successfully:', response)
          this.isLoading = false
        })
        .catch(e => {
          this.$swal({
            icon: 'error',
            title: `<h4>Error fetching category details: ${e.message}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

[dir] .dark-layout input.form-control,
[dir] .dark-layout .custom-file-label,
[dir] .dark-layout textarea.form-control {
  height: 45px;
  box-shadow: black beige indigo;
  border-radius: 8px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  background: linear-gradient(144deg, #1D133F 19%, #0E152B 41%, #12232F 87%);

  border: 2px solid #ffffff3c;
  border-left: none;
  border-right: none;
  border-top: none;
}
[dir] .dark-layout input.form-control:not(:focus),
[dir] .dark-layout .custom-file-label:not(:focus),
[dir] .dark-layout textarea.form-control:not(:focus) {
  border-color: #ffffff3c;
}

.field-icon {
  position: absolute;
  top: 10px;
  left: 30px;
  color: #ffffffcc !important;
  font-weight: 500;
}
</style>
